<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import EventBus from '@/event-bus'

@Component({
    props: {
        dialogVisible: Boolean,
        selectedObservation: Object
    }
})

export default class ObservationModal extends Vue {
    closeModal() {
        EventBus.$emit('close observation modal')
    }
    
    observationDate(observation) {
        return `${observation.MOTPMonth} ${observation.MOTPDay}, ${observation.MOTPYear}`
    }

    measuredComponents(observation) {
        return observation.componentsMeasured.filter(component => 
            component.Rating > 0
        )
    }
}
</script>

<template>
    <el-dialog width="70%"
        :visible="dialogVisible"
        @close="closeModal">
        <div class="meta">
            <div>
                <p>DATE</p>
                <p>CLASS</p>
                <p>OBSERVER</p>
            </div>
            <div>
                <p>{{ observationDate(selectedObservation) }}</p>
                <p>{{ selectedObservation.TimePeriod }}</p>
                <p>{{ selectedObservation.EvaluatorName }}</p>
            </div>
        </div>
        <div class="notes">
            <p>Additional Evaluator Notes</p>
            <p>{{ selectedObservation.Comments }}</p>
        </div>
        <p id="comp-scores">Component Scores</p>
        <div class="components"
            v-for="component in measuredComponents(selectedObservation)"
            :key="component.MOTPComponentID">
            <div class="comment">
                <div class="comment-header">
                    <p>{{ component.MOTPComponentDescription }}</p>
                    <span>{{ component.Rating }} out of 4</span>
                </div>
                <div class="comment-body">
                    <p>{{ component.ComponentRationale }}</p>
                </div>
            </div>
            <hr>
        </div>
    </el-dialog>
</template>

<style lang="scss" scoped>
    .meta {
        display: flex;
        padding: 25px;
        line-height: 2.5em;
        font-family: 'museo_sans', sans-serif;
        div {
            display: flex;
            flex-direction: column;
            align-content: space-between;
            padding: 5px 15px;
            &:first-child {
                border-right: 2px solid #979797;
            }
            p {
                margin: 0;
                font-size: 24px;
            }
        }
    }
    .notes {
        padding: 15px 50px;
        background-color: #f0f0f0;
        p:nth-child(1) {
            margin: 0 0 20px 0;
            color: #7a6263;
            font-size: 48px;
            font-family: 'museo_slab', sans-serif;
        }
        p:nth-child(2) {
            margin: 0 0 20px 0;
            color: #4a4a4a;
            font-size: 24px;
            font-family: 'museo_sans', sans-serif;
            line-height: 1.75em;
            white-space: pre-wrap;
        }
    }
    p#comp-scores {
        margin: 0;
        font-size: 48px;
        font-family: 'museo_slab', sans-serif;
        color: #779fa1;
        padding: 15px 50px;
    }
    .components {
        padding: 15px 50px;
        .comment {
            .comment-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                p {
                    margin: 0;
                    font-size: 20px;
                    color: #613f75;
                    font-family: 'museo_slab', sans-serif;
                }
                span {
                    font-size: 36px;
                    font-family: 'museo_sans', sans-serif;
                    color: #4a4a4a;
                }
            }
            .comment-body {
                p {
                    font-size: 20px;
                    line-height: 35px;
                    color: #4a4a4a;
                    font-family: 'museo_sans', sans-serif;
                    white-space: pre-wrap;
                }
            }
        }
        hr {
            color: #979797;
            border-width: 2px;
        }
        &:last-child hr {
            display: none;
        }
    }
    .el-dialog__wrapper {
        z-index: 100000001 !important;
    }
</style>
